import { Capacitor } from "@capacitor/core";
import * as LiveUpdates from "@capacitor/live-updates";

type EnvironmentName = "production" | "staging" | "development";

const CHANNEL_MAP: Record<EnvironmentName, string> = {
    production: "Production",
    staging: "Staging",
    development: "Development",
};

function getChannel(): string {
    const env = (process.env.REACT_APP_ENVIRONMENT_NAME?.replace(/"/g, "") || "production") as EnvironmentName;
    return CHANNEL_MAP[env] || "Production";
}

export async function configureLiveUpdates(): Promise<void> {
    const channel = getChannel();
    await LiveUpdates.setConfig({ channel });
    console.log(`[LiveUpdate] Configured channel: '${channel}'.`);
}

export async function syncLiveUpdate(): Promise<boolean> {
    const channel = getChannel();
    const result = await LiveUpdates.sync();

    if (result.activeApplicationPathChanged) {
        console.log(`[LiveUpdate] New update downloaded from channel '${channel}', will apply on reload.`);
        return true;
    }

    console.log(`[LiveUpdate] No new update available on channel '${channel}'.`);
    return false;
}

export async function reloadApp(): Promise<void> {
    await LiveUpdates.reload();
}

export function isNativePlatform(): boolean {
    return Capacitor.isNativePlatform();
}
